import cx from "classnames";
import { type HTMLAttributes, type PropsWithChildren } from "react";

import styles from "./stack.module.scss";

type StackProps = PropsWithChildren<HTMLAttributes<HTMLDivElement>> & {
  gap?: "sm" | "md" | "lg" | "xl" | "2xl";
};

export const Stack = ({
  children,
  gap = "xl",
  className,
  ...props
}: StackProps) => {
  return (
    <div
      className={cx(styles.stack, className, {
        [styles.gapSm]: gap === "sm",
        [styles.gapMd]: gap === "md",
        [styles.gapLg]: gap === "lg",
        [styles.gapXl]: gap === "xl",
        [styles.gap2Xl]: gap === "2xl",
      })}
      {...props}
    >
      {children}
    </div>
  );
};
